import { useSyncExternalStore } from 'react';
import { getRunnerUiSnapshot, subscribeRunnerUi } from '../../state/runnerUiStore.ts';
import { RUNNER_DOM } from './runnerDomIds.ts';

export function RunnerHud() {
  const d = RUNNER_DOM;
  const s = useSyncExternalStore(subscribeRunnerUi, getRunnerUiSnapshot, getRunnerUiSnapshot);

  const hearts = (() => {
    const L = Math.max(0, s.lives);
    return '❤️'.repeat(L) + '🖤'.repeat(Math.max(0, 3 - L));
  })();

  return (
    <div id={d.root} className="runner-ui" hidden={!s.hudVisible}>
      <header className="runner-ui__header">
        <div className="runner-ui__lives">{hearts}</div>
        <div className="runner-ui__score-block">
          <span className="runner-ui__score-label">Score</span>
          <span className="runner-ui__score">{s.score}</span>
        </div>
      </header>
    </div>
  );
}
